import { useState } from 'react';
import classNames from 'classnames';
import { ErrorMessage, FormikProvider, useFormik } from 'formik';
import { Button, Modal, showNotificationMessage } from '../..';
import styles from './index.module.css';
import * as Yup from "yup";
import Papa from "papaparse";
import { riderImportTemplate } from '../../../utils/RiderImportTemplate';

export const useRiderBulkImportModal = ({ onConfirm }) => {
  const downloadTemplate = () => {
    const blob = new Blob([riderImportTemplate], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Import_riders_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const validationSchema = Yup.object().shape({
    file: Yup.mixed()
      .required("A CSV file is required")
      .test("fileType", "Only CSV files are allowed", (value) => {
        return value && value.type === "text/csv";
      })
  });

  const formik = useFormik({
    initialValues: { file: null },
    validationSchema,
  });

  const { values, setFieldValue } = formik;

  const [visible, setModalVisible] = useState(false);

  const onClose = (() => {
    setModalVisible(false);
  });

  const handleSubmit = (file) => {
    if (file?.type !== "text/csv") {
      showNotificationMessage({
        type: 'error',
        content: 'Only CSV files are allowed',
        duration: 5,
      });
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const parsedData = results.data;
        console.log('parsedData', parsedData);
        console.log('selected File', file);
        try {
          onConfirm({ parsedData, fileName: file.name });
          onClose();
        } catch (err) {
          console.error("Error calling onImport:", err);
        }
      }
    });
  };


  return {
    Modal: (
      <Modal
        visible={visible}
        onCancel={onClose}
        title="Import Riders"
        closable width={670}
        className={styles.modal}
      >
        <div className={styles.modalContent}>
          <p className={styles.modalDescription}>Please select a file to upload rider data
          </p>
          <FormikProvider value={formik}>
            <form className={styles.form} >
              <div className={styles.formGroup}>
                <input
                  id="fileRiderImport"
                  name="file"
                  type="file"
                  accept=".csv"
                  style={{ display: "none" }}
                  onChange={(event) => {
                    const file = event.currentTarget.files[0];
  
                    if (file) {
                      setFieldValue("file", file);
                      handleSubmit(file); // submit right after selection
                    }
                  }}
                />
              </div>
              <div className={styles.modalBtns}>
                <Button
                  type="button"
                  onClick={downloadTemplate}
                  myClassName={classNames({
                    [styles.navigationBtn]: true,
                    [styles.cancelBtn]: true,
                  })}
                >
                  Download Template
                </Button>
                <Button myClassName={styles.navigationBtn} className={styles.submitButton}
                  onClick={() => document.getElementById("fileRiderImport").click()}>
                  Upload
                </Button>
              </div>
            </form>
          </FormikProvider>
        </div>
      </Modal>
    ),
    setImportModalVisible: setModalVisible,
  }
};
